"use client";

import * as React from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface MapPanelIndicatorProps {
  indicator?: React.ReactNode;
  className?: string;
}

export const MapPanelIndicator: React.FC<MapPanelIndicatorProps> = ({
  indicator,
  className,
}) => {
  if (!indicator) {
    return null;
  }

  return (
    <div
      className={cn(
        "absolute -right-1 -top-1 z-10 flex items-center justify-center",
        className,
      )}
    >
      {indicator}
    </div>
  );
};

